import { NextButtonField } from '../checkInReserve/nextButtonField';
import '../util/bpUtilStyle.css';
import { FactoryInfoCard } from '../util/common/factoryInfoCard';
import { CheckInDateEntryField } from './checkInDateEntryField';
import './checkInReserveDateStyle.css';

interface CheckInReserveDateProps {
  disabled: boolean;
  onNext: () => void;
  calendarInfo: {
    header: {
      label: string;
      onPrev: () => void;
      onNext: () => void;
    };
    date: {
      dateLabel: string;
      selectStyle: string;
      reserveStyle: string;
      onClick: () => void;
    }[][];
    time: {
      dateLabel: string;
      onClick: () => void;
      selectStyle: string;
    }[];
  };
  plantInfo: {
    pickerID: string;
    state: {
      id: number;
      name: string;
      address: string;
      phone: string;
    };
  };
}
export const CheckInReserveDate = ({
  calendarInfo,
  plantInfo: {
    pickerID,
    state: { name: plantName, address: plantPhone, phone: plantAddress },
  },
  disabled,
  onNext,
}: CheckInReserveDateProps) => {
  return (
    <div className={'change-check-in-date-field'}>
      <CheckInDateEntryField props={calendarInfo} />
      <div className={'factory-info-field'} id={pickerID}>
        <FactoryInfoCard
          factoryName={plantName ?? '未選択'}
          telephone={plantPhone}
          address={plantAddress}
        />
        <NextButtonField disable={disabled} onClick={onNext} />
      </div>
    </div>
  );
};
